// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KrEk","colBig":"styles_colBig__2R2Zz","colSmall":"styles_colSmall__1NtZS","shopifyNameWrapper":"styles_shopifyNameWrapper__3eAhd"};